<!-- <div class="fadeinright animation-duration-200">
  <div class="px-5 pt-6">
    <div class="flex text-center">
      <h2>¿Realizaste todo el proceso completo?</h2>
    </div>
    <div class="flex w-full justify-content-center mt-5">
      <p-button label="Si, realice todo el proceso" (click)="onContinueEnrollment()"></p-button>
    </div>
    <div class="flex flex-column align-items-center justify-content-center gap-2 mt-8">
      <p class="font-normal">Puedes volver al paso anterior si crees que no esta listo </p>
      <p-button severity="secondary" [outlined]="true" label="Volver" icon="pi pi-arrow-left" (onClick)="onReturnEnrollment()"></p-button>
    </div>
  </div>
</div> -->


<p-dialog [(visible)]="visibleModalEndProcess" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>¿Realizaste todo el proceso completo?</h2>
          <p>Puedes volver al paso anterior si crees que no estás listo.</p>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Si, realicé todo el proceso" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onContinueEnrollment()"></button>
          <div class="dialog__btnFloat">
            <p-button label="Volver al paso anterior" icon="pi pi-arrow-left" iconPos="left" [text]="true" [plain]="true" (onClick)="onReturnEnrollment()"></p-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
